export default "__VITE_ASSET__ST8barsFccBS2ZwMSaSnzA__"